import { PreviewModal } from "components/ChatPreviewModal/ChatPreviewModal";
import { Button } from "components/DesignSystem/Button/Button";
import { DownloadIcon } from "components/icons/Download";
import { PdfPreview } from "components/PreviewModal";
import PreviewImageName from "static/images/PreviewImageName.svg";

type ChatPdfPreviewModalProps = {
  name: string;
  url: string | null;
  onClose: () => void;
};

export const ChatPdfPreviewModal = ({
  name,
  url,
  onClose,
}: ChatPdfPreviewModalProps) => {
  if (!url) return null;

  const handleDownload = () => {
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = name;
    anchor.click();
  };

  return (
    <PreviewModal
      open
      onClose={onClose}
      title={
        <>
          <img src={PreviewImageName} alt={name} />
          {name}
          <Button customType="ghost" size="small" onClick={handleDownload}>
            <div className="t-text-neutral-0 group-hover:t-text-neutral-100">
              <DownloadIcon color="currentColor" />
            </div>
          </Button>
        </>
      }
    >
      <PdfPreview preview_url={url} name={name} />
    </PreviewModal>
  );
};
